import * as React from 'react'
import { InnerContainer } from '../../shared/components/Elements'
import { styled } from '../../shared/styled-components'
import { Utils } from '../../shared/Utils'

export class Footer extends React.Component {
  render() {
    return (
      <FooterContainer>
        <InnerFooterContainer>
          <Logo src={Utils.getAssetPath('/assets/calculator/result/footer-logo.svg')} />
          <Links>
            <FooterLink href="https://implacheck.de" target="_blank">
              Startseite
            </FooterLink>
            <FooterLink href="https://implacheck.de/impressum" target="_blank">
              Impressum
            </FooterLink>
            <FooterLink href="https://implacheck.de/datenschutz" target="_blank">
              Datenschutz
            </FooterLink>
          </Links>
        </InnerFooterContainer>
      </FooterContainer>
    )
  }
}

const FooterContainer = styled.div`
  padding: 50px 0;
  background: white;
  @media (max-width: 950px) {
    padding: 50px 20px;
  }
  @media print { 
  display: none;
  }
`

const Logo = styled.img``

const FooterLink = styled.a`
  font-weight: ${(props) => props.theme.textFont};
  color: ${(props) => props.theme.darkBlueColor};
  text-decoration: none;
  margin-right: 30px;
  &:last-child {
    margin-right: 0;
  }
`

const Links = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 600px) {
    margin-top: 20px;
    padding-bottom: 20px;
  }
`

const InnerFooterContainer = styled(InnerContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 65px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`
